import React, { Component } from 'react';

import './SelectCarCardSmMobile.css';

import FaCalendar from 'react-icons/lib/fa/calendar';
import FaAutomobile from 'react-icons/lib/fa/automobile';
import FaExternalLink from 'react-icons/lib/fa/external-link';
import FaCheck from 'react-icons/lib/fa/check';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { getTranslate } from 'react-localize-redux';
import { formValueSelector } from 'redux-form';
import creditCards from '../../assets/images/creditcards.png';
import Gel from '../Svgs/Gel'


class SelectedCarCardSmMobile extends Component {
  render() {
    const {
      vehicleCategoryName,
      translate,
      issueDateDiff,
      dayType,
      startDate,
      endDate,
      premium,
      canPay,
      isLoading,
      onClick,
    } = this.props;
    return (
  <div className="select-policy-reg-head-small-mobile">
           <p>{vehicleCategoryName ? translate(vehicleCategoryName) : '- - - -'}-</p>
           <p>{issueDateDiff ? issueDateDiff  : '_ _'}</p>
           <p>{ dayType ? translate(dayType): '---'}-</p>
           <p>{translate('price')}{ " " }{premium ? premium : '-' + '-'}<Gel width={10}/></p>  
            {/* <a href="#" target="_blank" className="insurer-conditions-text">
                {translate('insuranceCondition')}  <FaExternalLink />
            </a> */}
        </div>
        );
  }
}

const selector = formValueSelector('CreatePolicyForm');

const mapStateToProps = state => {
  const startDate = selector(state, 'startDate');
  const endDate = selector(state, 'endDate');
  const issueDateDiff = selector(state, 'issueDateDiff');
  const dayType = selector(state, 'dayType');
  const vehicleCategoryName = selector(state, 'vehicleCategoryName');
  const premium = selector(state, 'premium');
  return {
    translate: getTranslate(state.locale),
    startDate,
    endDate,
    issueDateDiff,
    dayType,
    premium,
    vehicleCategoryName,
  };
};

export default connect(mapStateToProps)(SelectedCarCardSmMobile);



// WEBPACK FOOTER //
// ./src/components/Select-Car-Card-Sm-Mobile/SelectCarCardSmMobile.js